import { ApexChart } from "apex-react-charts";
import React from "react";
import S from "./style.module.scss";

const BarChart = ({ title, height = 180, xaxis = [], data = [], min, max }) => {
  const series = [...data];

  const options = {
    chart: {
      type: "bar",
      height: height,
      stacked: true,
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 10,
      },
    },
    tooltip: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
      offsetX: 40,
      onItemClick: {
        toggleDataSeries: false,
      },
    },
    fill: {
      opacity: 1,
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#4CD5BA", "#6A5DFA", "#F25449"],
  };
  return (
    <>
      <div className={S.header}>
        <h1 className={S.headerTitle}>{title}</h1>
      </div>
      <ApexChart options={options} series={series} type="line" />
    </>
  );
};

export default React.memo(BarChart);
